import { FC } from 'react';
import { RenderIf } from 'shared/helpers/renderIf';
import { ProductToUpdate } from 'shared/types';
import styled from 'styled-components';
import ErrorIcon from '@mui/icons-material/ErrorOutline';
import { Text } from 'entities/Text';

type DistributedComponentProps = {
  bgColor: '#ffc7c3' | '#ffffaab2';
};

type ErrorMessageType = {
  title: string;
};

export const FooterText = styled(Text)`
  font-weight: 500;
  color: #1565c0;
  width: 100%;
  text-align: right;
`;

export const deliveryNoteNumCell = (el: any) => {
  return (
    <>
      <RenderIf condition={el.id === 'auto-generated-group-footer-root' && !el.value}>
        <FooterText>Total:</FooterText>
      </RenderIf>
      <RenderIf condition={el.id !== 'auto-generated-group-footer-root'}>{el.value || ''}</RenderIf>
    </>
  );
};

export const DistributedComponent = styled('div')<DistributedComponentProps>`
  width: calc(100% + 20px);
  height: 100%;
  margin: 0 -10px;
  padding: 0 10px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  background: green;
  background: ${({ bgColor }) => bgColor};
`;

export const distributedCell = (products: ProductToUpdate[]) => (el: any) => {
  const getBgColor = () =>
    products.some((p) => p.id === `${el.row.customerNum}_${el.row.deliveryNoteNum}`)
      ? '#ffc7c3'
      : '#ffffaab2';
  return (
    <>
      <RenderIf condition={el.id === 'auto-generated-group-footer-root'}>
        <FooterText>{el.value || ''}</FooterText>
      </RenderIf>
      <RenderIf condition={el.isEditable && el.value}>
        <DistributedComponent bgColor={getBgColor()}>{el.value}</DistributedComponent>
      </RenderIf>
      <RenderIf
        condition={el.id !== 'auto-generated-group-footer-root' && (!el.isEditable || !el.value)}
      >
        {el.value || ''}
      </RenderIf>
    </>
  );
};

export const editableCell = (el: any) => {
  return (
    <>
      <RenderIf condition={el.id === 'auto-generated-group-footer-root'}>
        <FooterText>{el.value || ''}</FooterText>
      </RenderIf>
      <RenderIf condition={el.isEditable}>
        <DistributedComponent bgColor={'#ffffaab2'}>{el.value || ''}</DistributedComponent>
      </RenderIf>
      <RenderIf condition={el.id !== 'auto-generated-group-footer-root' && !el.isEditable}>
        {el.value || ''}
      </RenderIf>
    </>
  );
};

export const OrderModalContainer = styled.div`
  overflow: scroll;
  width: 80vw;
`;

export const StartContainer = styled.div`
  display: grid;
  grid-template-columns: 350px 1fr;
  grid-template-rows: 350px 1fr 20px;

  margin: 25px;
  grid-row-gap: 0px;
  grid-column-gap: 25px;

  max-width: 100%;
`;

export const ProductImage = styled.img`
  object-fit: contain;
  max-height: 100%;
  max-width: 100%;
`;

export const StartModalHeader = styled(Text)`
  display: flex;
  padding: 16px 0px;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;

  color: var(--text-primary, rgba(0, 0, 0, 0.87));
  font-feature-settings: 'clig' off, 'liga' off;

  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: 160%;
  letter-spacing: 0.15px;
`;

export const ErrorMessageStyled = styled.div`
  position: absolute;
  top: 64px;
  right: 0;
  width: 400px;
  height: 96px;
  background-color: #fdeded;
  color: #5f2120;
  padding: 10px 16px;

  display: flex;
  flex-direction: row;
  gap: 12px;

  & p {
    color: var(--alert-error-content, #5f2120);

    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0.17px;
  }
`;

export const ErrorMessageTitle = styled.span`
  color: var(--alert-error-content, #5f2120);
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: 0.15px;
`;

export const ErrorMessage: FC<ErrorMessageType> = ({ title, children }) => {
  return (
    <ErrorMessageStyled>
      <ErrorIcon sx={{ color: '#D32F2F' }} />
      <div>
        <ErrorMessageTitle>{title}</ErrorMessageTitle>
        <Text>{children}</Text>
      </div>
    </ErrorMessageStyled>
  );
};

export const InputsContainer = styled.div`
  position: relative;
  max-width: 100vw;
  @media (max-width: 800px) {
    max-width: 90vw;
  }
`;

export const ButtonsContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-bottom: 25px;
  // TODO: use global var instead of 800px
  @media (max-width: 800px) {
    margin-bottom: unset;
    max-width: 90vw;
  }
`;

export const RadioInputContainer = styled.div`
  display: flex;
  margin-bottom: 40px;

  // TODO: use global var instead of 800px
  @media (max-width: 800px) {
    flex-direction: column;
    margin-bottom: unset;
    /* max-width: 90vw; */
  }
`;

export const TextFieldBox = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 10px;
  height: 56px;
  margin-top: 56px;
  @media (max-width: 800px) {
    margin-top: 20px;
  }
`;

export const DescriptionComponentContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-template-rows: 1fr 1fr;
  padding: 10px;
  width: 100%;
`;

export const DescriptionComponentTitle = styled.div`
  grid-column: 1 / -1;
  font-size: 20px;
  font-weight: 500;
  line-height: 32px;
  letter-spacing: 0.15px;
  text-align: left;
`;

export const DescriptionComponentSubItem = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 14px;
  font-weight: 500;
  line-height: 22px;
  letter-spacing: 0.1px;
  text-align: left;
  p:nth-child(even) {
    font-weight: 500;
  }
`;
